import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class ApplicationConfigService {
  private readonly baseUrl = environment.services.admin;
  private readonly userIssueBaseUrl = environment.services.userissue;
  private readonly userIssueHubBaseUrl = environment.services.userissuehub;

  getEndpointFor(prefix = '/admin/api/v1'): string {
    return `${this.baseUrl}${prefix}`;
  }

  getEndpointWithoutPrefix(): string {
    return `${this.baseUrl}`;
  }

  getUserIssueEndpoint(prefix = '/userissue/api/v1'): string {
    return `${this.userIssueBaseUrl}${prefix}`;
  }

  getUserIssueEndpointWithoutPrefix(): string {
    return `${this.userIssueBaseUrl}`;
  }

  getUserIssueEndpointForHub(): string {
    return `${this.userIssueHubBaseUrl}`;
  }
}
